import { useNavigate } from 'react-router-dom';
import CustomModal from '../../../../../../components/modal/CustomModal';
import { InlineWidget } from 'react-calendly';
import CustomButton from '../../../../../../components/button/CustomButton';
import { Divider, Stack } from '@mui/material';

const CalendlyModal = ({
  open,
  showActionBtn,
  caseStudyId,
  handleCancel,
}: {
  open: boolean;
  showActionBtn: boolean;
  caseStudyId: string;
  handleCancel: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <CustomModal
      width={{ xs: '80%', sm: '70%', lg: '50%' } as Record<string, string>}
      paperStyleProps={{ p: { xs: '2rem', lg: '2rem' } }}
      open={open}
    >
      <Stack spacing={2}>
        <InlineWidget url={process.env.REACT_APP_CALENDLY_URL as string} />
        <Divider />
        <Stack direction="row" sx={{ justifyContent: 'right' }} spacing={4}>
          {showActionBtn ? (
            <CustomButton
              sx={{ mt: 2 }}
              onClick={() => navigate(`../case-study/${caseStudyId}/submit-review`)}
            >
              Continue
            </CustomButton>
          ) : (
            <CustomButton variant="primaryLight" sx={{ mt: 2 }} onClick={handleCancel}>
              Cancel
            </CustomButton>
          )}
        </Stack>
      </Stack>
    </CustomModal>
  );
};

export default CalendlyModal;
